import React from "react";
import BlogContent from "../../Views/BlogContent"; // Import BlogContent from src/Views
import ViewGallery from "../../Views/ViewGallery"; // Import ViewGallery from src/Views
import SecRowGallery from "../../Views/SecRowGallery"; // Import SecRowGallery from src/Views
import GamesGrid from "../../components/Games/GamesGrid"; // Import GamesGrid from src/components/Games

import "./WebHomePage.css"; // Import styles for WebHomePage

const WebHomePage = () => {
  return (
    <div className="WebHomePage">
      <h1></h1>
      <p></p>

      {/* Render BlogContent */}
      <BlogContent />

      {/* Render GamesGrid */}
      <GamesGrid />

      {/* Render ViewGallery */}
      <ViewGallery />

      {/* Render SecRowGallery */}
      <SecRowGallery />
    </div>
  );
};

export default WebHomePage;
